export default "__VITE_ASSET__aef231b7__"